import type { EduAssetListResponseContentItem } from './eduAssetListResponseContentItem';
import type { EduAssetListResponsePageable } from './eduAssetListResponsePageable';

/**
 * 강의 자료 목록 응답
 */
export interface EduAssetListResponse {
  content?: EduAssetListResponseContentItem[];
  /** Spring Data Page 객체 형태의 페이징 정보 */
  pageable?: EduAssetListResponsePageable;
}
